export const PREVIEW_DEVICE_OVERRIDE_CHANGE_EVENT = 'minimany:preview-device-override-change'
export const PREVIEW_DEVICE_OVERRIDE_STORAGE_KEY = 'minimany:preview-device-override:v1'

export type PreviewDeviceOverride = 'off' | 'android-phone' | 'android-tablet'

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>

function previewOverridesAvailable(): boolean {
  return import.meta.env.DEV
}

function availableStorage(): StorageLike | null {
  if (typeof localStorage === 'undefined') return null
  return localStorage
}

export function isPreviewDeviceOverride(value: unknown): value is PreviewDeviceOverride {
  return value === 'off' || value === 'android-phone' || value === 'android-tablet'
}

export function readPreviewDeviceOverride(storage = availableStorage()): PreviewDeviceOverride {
  if (!previewOverridesAvailable() || !storage) return 'off'
  try {
    const value = storage.getItem(PREVIEW_DEVICE_OVERRIDE_STORAGE_KEY)
    return isPreviewDeviceOverride(value) ? value : 'off'
  } catch {
    return 'off'
  }
}

export function writePreviewDeviceOverride(
  value: PreviewDeviceOverride,
  browserWindow: Window = window,
  storage = availableStorage(),
): void {
  if (!previewOverridesAvailable() || !storage) return
  try {
    storage.setItem(PREVIEW_DEVICE_OVERRIDE_STORAGE_KEY, value)
  } catch {
    return
  }
  browserWindow.dispatchEvent(new Event(PREVIEW_DEVICE_OVERRIDE_CHANGE_EVENT))
}

export function previewDeviceOverrideLabel(value: PreviewDeviceOverride): string {
  if (value === 'android-phone') return 'Android phone · touch controls · 393 × 852 target'
  if (value === 'android-tablet') return 'Android tablet · touch controls · 800 × 1280 target'
  return 'Off · actual runtime'
}
